module.exports = __webpack_public_path__ + "img/Improvement_none_icon.592232a7.png";